export const MATTERS = [{
  id: 'm-1',
  caseNumber: '2023-CV-04821',
  name: 'Ramirez v. Lone Star Freight',
  type: 'Personal Injury — Trucking',
  status: 'Active — Discovery',
  lastUpdated: '2 hours ago',
  attorney: 'Sarah Jenkins',
  documentsCount: 441,
  pendingReviews: 3
}, {
  id: 'm-2',
  caseNumber: '2023-CV-05102',
  name: 'Castillo v. Westfield Properties LLC',
  type: 'Premises Liability',
  status: 'Pre-Litigation',
  lastUpdated: '1 day ago',
  attorney: 'David Chen',
  documentsCount: 127,
  pendingReviews: 1
}, {
  id: 'm-3',
  caseNumber: '2022-CV-03847',
  name: 'Ortega v. Gulf Coast Industrial',
  type: 'Workplace Injury',
  status: 'Settlement Negotiations',
  lastUpdated: '3 days ago',
  attorney: 'Sarah Jenkins',
  documentsCount: 892,
  pendingReviews: 0
}, {
  id: 'm-4',
  caseNumber: '2024-CV-00412',
  name: 'Garcia v. Metro Transit Authority',
  type: 'Auto Accident — Municipal',
  status: 'Active — Discovery',
  lastUpdated: '4 hours ago',
  attorney: 'Michael Ross',
  documentsCount: 234,
  pendingReviews: 2
}, {
  id: 'm-5',
  caseNumber: '2024-CV-00891',
  name: "Nguyen v. St. Luke's Medical Center",
  type: 'Medical Malpractice',
  status: 'Trial Prep',
  lastUpdated: '5 mins ago',
  attorney: 'Jessica Pearson',
  documentsCount: 1847,
  pendingReviews: 4
}, {
  id: 'm-6',
  caseNumber: '2024-CV-01203',
  name: 'Thompson v. ABC Trucking Inc.',
  type: 'Wrongful Death — Commercial Vehicle',
  status: 'Pre-Litigation',
  lastUpdated: '1 week ago',
  attorney: 'Sarah Jenkins',
  documentsCount: 56,
  pendingReviews: 1
}];
export const RECENT_DOCUMENTS = [{
  id: 'd-1',
  name: 'Ramirez_Medical_Records_Part1.pdf',
  type: 'Medical Record',
  matter: 'Ramirez v. Lone Star Freight',
  date: 'Oct 24, 2023',
  confidence: 98,
  batesRef: 'RLSF-0013'
}, {
  id: 'd-2',
  name: 'Police_Report_Garcia.pdf',
  type: 'Official Report',
  matter: 'Garcia v. Metro Transit Authority',
  date: 'Oct 23, 2023',
  confidence: 100,
  batesRef: 'GMTA-0001'
}, {
  id: 'd-3',
  name: 'Deposition_Transcript_Dr_Patel.docx',
  type: 'Transcript',
  matter: "Nguyen v. St. Luke's Medical Center",
  date: 'Oct 20, 2023',
  confidence: 95,
  batesRef: 'NSLM-0892'
}, {
  id: 'd-4',
  name: 'Site_Photos_Castillo.zip',
  type: 'Evidence',
  matter: 'Castillo v. Westfield Properties LLC',
  date: 'Oct 19, 2023',
  confidence: 0,
  batesRef: 'CWPL-0045'
}];
export const WORKFLOWS = [{
  id: 'w-1',
  name: 'Bates Label Production',
  description: 'Auto-number and stamp production sets',
  status: 'Ready',
  assignedTo: 'Ana Torres',
  matter: 'Ramirez v. Lone Star Freight',
  lastRunStatus: 'Success',
  reviewCheckpoint: 'Spot Check (10%)'
}, {
  id: 'w-2',
  name: 'Generate Medical Chronology',
  description: 'Extract timelines from medical records',
  status: 'Active',
  assignedTo: 'Sarah Jenkins',
  matter: "Nguyen v. St. Luke's Medical Center",
  lastRunStatus: 'Completed w/ Flags',
  reviewCheckpoint: 'Full Attorney Review'
}, {
  id: 'w-3',
  name: 'Classify Production Set',
  description: 'Sort incoming documents by type',
  status: 'Ready',
  assignedTo: 'David Chen',
  matter: 'Garcia v. Metro Transit Authority',
  lastRunStatus: 'Success',
  reviewCheckpoint: 'Threshold Review (<85%)'
}, {
  id: 'w-4',
  name: 'Intake Folder Creation',
  description: 'Setup standard folder structure for new matters',
  status: 'Ready',
  assignedTo: 'System',
  matter: 'Thompson v. ABC Trucking Inc.',
  lastRunStatus: 'Success',
  reviewCheckpoint: 'None (Automated)'
}, {
  id: 'w-5',
  name: 'Extract Deposition Summary',
  description: 'Generate key testimony summaries from transcripts',
  status: 'Queued',
  assignedTo: 'Jessica Pearson',
  matter: "Nguyen v. St. Luke's Medical Center",
  lastRunStatus: 'Failed',
  reviewCheckpoint: 'Full Attorney Review'
}, {
  id: 'w-6',
  name: 'Email-to-Matter Filing',
  description: 'Route incoming emails to appropriate matter folders',
  status: 'Ready',
  assignedTo: 'Ana Torres',
  matter: 'Ramirez v. Lone Star Freight',
  lastRunStatus: 'Success',
  reviewCheckpoint: 'Threshold Review (<90%)'
}, {
  id: 'w-7',
  name: 'Break Referred Case',
  description: 'Split referred case into sub-matters with shared corpus',
  status: 'Ready',
  assignedTo: 'Sarah Jenkins',
  matter: 'Thompson v. ABC Trucking Inc.',
  lastRunStatus: 'N/A',
  reviewCheckpoint: 'Full Attorney Review'
}];
export const REVIEW_QUEUE = [{
  id: 'r-1',
  task: 'Pre-existing Condition Mention',
  type: 'Chronology Conflict',
  matter: 'Ramirez v. Lone Star Freight',
  aiConfidence: 72,
  date: 'Today',
  assignedTo: 'Sarah Jenkins',
  priority: 'High',
  sourceDoc: 'Dr. Smith Orthopedic Consultation Notes.pdf'
}, {
  id: 'r-2',
  task: 'Verify Document Classification',
  type: 'Classification',
  matter: 'Garcia v. Metro Transit Authority',
  aiConfidence: 68,
  date: 'Today',
  assignedTo: 'David Chen',
  priority: 'Medium',
  sourceDoc: 'Defendant_Production_Set_A.zip'
}, {
  id: 'r-3',
  task: 'Review Draft Interrogatories',
  type: 'Draft Review',
  matter: "Nguyen v. St. Luke's Medical Center",
  aiConfidence: 88,
  date: 'Yesterday',
  assignedTo: 'Jessica Pearson',
  priority: 'High',
  sourceDoc: 'Draft_Interrogatories_StandardOfCare.docx'
}, {
  id: 'r-4',
  task: 'Potential Work Product Designation',
  type: 'Privilege Flag',
  matter: 'Ramirez v. Lone Star Freight',
  aiConfidence: 100,
  date: 'Yesterday',
  assignedTo: 'Sarah Jenkins',
  priority: 'Low',
  sourceDoc: 'Demand Letter Draft — v3.docx'
}, {
  id: 'r-5',
  task: 'Conflicting Treatment Dates',
  type: 'Chronology Conflict',
  matter: 'Castillo v. Westfield Properties LLC',
  aiConfidence: 65,
  date: 'Oct 22',
  assignedTo: 'David Chen',
  priority: 'High',
  sourceDoc: 'Castillo_PT_Records_Q3.pdf'
}];
export const SEARCH_RESULTS = [{
  id: 's-1',
  title: 'Dr. Smith Deposition — Page 42',
  excerpt: '...the patient exhibited signs of severe trauma to the L4-L5 region immediately following the incident...',
  matter: "Nguyen v. St. Luke's Medical Center",
  relevance: 98,
  type: 'Transcript',
  batesRef: 'NSLM-0345'
}, {
  id: 's-2',
  title: 'Initial ER Evaluation',
  excerpt: 'Patient arrived via ambulance complaining of lower back pain radiating down the left leg.',
  matter: 'Ramirez v. Lone Star Freight',
  relevance: 95,
  type: 'Medical Record',
  batesRef: 'RLSF-0014'
}, {
  id: 's-3',
  title: 'Expert Witness Report — Dr. Allen',
  excerpt: 'It is my professional opinion that the trauma described is consistent with a high-impact collision.',
  matter: 'Garcia v. Metro Transit Authority',
  relevance: 82,
  type: 'Expert Report',
  batesRef: 'GMTA-0112'
}];